import { stringify } from "qs";
import { getHeaders, makeRequest, fetch } from "$utils/utils";
import config from "./config";

const url = config.api_url;

export const getLocations = async (params) => {
  const search = { input: params.locationName };
  try {
    const res = await fetch(`/api/locations/?${stringify(search)}`);

    return {
      data: res.data.map((r) => ({
        ...r,
        locationName: r.structured_formatting.main_text,
      })),
    };
  } catch (err) {
    console.error(err);
    return { error: err?.message ?? null };
  }
};

export const getLocationDetail = async (place_id) => {
  try {
    const res = await fetch(
      `/api/locations/details/?${stringify({ place_id })}`
    );

    return { data: res };
  } catch (err) {
    return { error: (err as any)?.message ?? null };
  }
};

export const GetLocations = async (input: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/locations/?input=${input}`,
      "GET",
      undefined,
      getHeaders()
    );
    if (!res || !res.data) {
      throw new Error("No locations founded");
    }
    return res.data;
  } catch (err) {
    return { error: (err as any)?.message ?? null };
  }
};

export const GetLocationDetail = async (placeId: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/locations/details/?place_id=${placeId}`,
      "GET",
      undefined,
      getHeaders()
    );
    if (!res || !res.data) {
      throw new Error("No location details founded");
    }
    return res.data;
  } catch (err) {
    return { error: (err as any)?.message ?? null };
  }
};
